<template>
  <v-container class="pa-0">

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('provincia') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.province.nombre }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('altitud') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ altitudNombre(escenario.altitude) }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('climatica_consid') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.climaticZone.nombre }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('anyo_construccion') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.yearConstruction.name }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('estado_conservacion') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.stateConservation.name }}</v-col>
    </v-row>

    <v-row class="font-weight-bold" no-gutters>
      <v-col cols="12">{{ $t('revestimiento_existente') }}</v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" class="ml-4">{{ escenario.existingCoating.name }}</v-col>
    </v-row>

  </v-container>
</template>

<script>
export default {
  name: "EscenarioHorizontal",
  props: {
    escenario: {type: Object, required: true}
  },
  methods: {
    altitudNombre(altitud) {
      return altitud === "desc" ? "Desconocida" : altitud + " metros";
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "provincia": "Provincia",
    "altitud": "Altitud (metros)",
    "climatica_consid": "Zona climática considerada",
    "anyo_construccion": "Año de construcción",
    "estado_conservacion": "Estado de conservación",
    "revestimiento_existente": "Revestimiento existente"
  }
}
</i18n>
<!--@formatter:on-->